import { heatmapTone, type HeatmapResult, type HeatmapTone } from './serp-heatmap.js';

export const SERP_TILE_METRICS = ['owned', 'fake', 'competitor', 'review'] as const;
export type SerpTileMetric = (typeof SERP_TILE_METRICS)[number];
export const DEFAULT_SERP_TILE_METRICS: SerpTileMetric[] = ['owned', 'fake', 'competitor'];
export const SERP_TILE_METRIC_DEFINITIONS: Record<
  SerpTileMetric,
  { label: string; compactLabel: string; tone: HeatmapTone; includes: readonly HeatmapTone[] }
> = {
  owned: { label: 'Наши', compactLabel: 'Наши', tone: 'owned', includes: ['owned'] },
  fake: { label: 'Фейки', compactLabel: 'Фейки', tone: 'fake', includes: ['fake'] },
  competitor: {
    label: 'Конкуренты',
    compactLabel: 'Конк.',
    tone: 'competitor',
    includes: ['competitor'],
  },
  review: {
    label: 'На разбор',
    compactLabel: 'Разбор',
    tone: 'unreviewed',
    includes: ['unreviewed', 'unknown', 'conflict'],
  },
};

// A category occupies a rank once, even when multiple URLs share that rank.
// Categories may overlap; these are independent meters, not parts of a total.
export function queryPositionMetrics(results: readonly HeatmapResult[], top: number) {
  const current = results.filter((result) => result.rank >= 1 && result.rank <= top);
  return Object.fromEntries(
    SERP_TILE_METRICS.map((key) => {
      const ranks = new Set(
        current
          .filter((result) =>
            SERP_TILE_METRIC_DEFINITIONS[key].includes.includes(heatmapTone(result)),
          )
          .map((result) => result.rank),
      );
      return [key, { count: ranks.size, bestRank: ranks.size ? Math.min(...ranks) : null }];
    }),
  ) as Record<SerpTileMetric, { count: number; bestRank: number | null }>;
}
